module.exports = __webpack_public_path__ + "static/img/point-welfare.5817d76.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/promotion/point-welfare.png
// module id = 4lE6
// module chunks = 2